<template>
  <div v-if="$store.state.responsive.viewDesktopFilters" id="client-filters">
    <form @submit.prevent="filter()" v-on:keypress.enter.prevent="enterKey">
      <div class="row">
        <div class="col-12 col-lg-3">
          <div class="form-group">
            <label class="generalLabel" for="name" v-if="!$store.state.roles.Backoffice_member_empresas">Nombre</label>
            <label class="generalLabel" for="name" v-if="$store.state.roles.Backoffice_member_empresas">Nombre de la compañía</label>
            <input type="text" class="form-control generalInput" id="name" v-model.trim="name">
          </div>
        </div>
        <div class="col-12 col-lg-3" v-if="!$store.state.roles.Backoffice_member_empresas">
          <div class="form-group">
            <label class="generalLabel" for="surnames">Apellidos</label>
            <input type="text" class="form-control generalInput" id="surnames" v-model.trim="surnames">
          </div>
        </div>
        <div class="col-12 col-lg-3">
          <div class="form-group">
            <label class="generalLabel" for="email">Email</label>
            <input type="text" class="form-control generalInput" id="email" v-model.trim.lazy="v$.email.$model">
            <small class="form-text text-danger" v-if="v$.email.$invalid">Formato incorrecto</small>
          </div>
        </div>
        <div class="col-12 col-lg-3" v-if="!$store.state.roles.Backoffice_member_empresas">
          <div class="form-group">
            <label class="generalLabel" for="documentNumber">DNI</label>
            <input type="text" class="form-control generalInput" id="documentNumber"
              v-model.trim.lazy="v$.documentNumber.$model">
            <div v-if="v$.documentNumber.$dirty">
              <small class="form-text text-danger" v-if="v$.documentNumber.dniNumber.$invalid">DNI
                incorrecto</small>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-3" v-if="$store.state.roles.Backoffice_member_empresas">
          <div class="form-group">
            <label class="generalLabel" for="documentNumberCompany">CIF</label>
            <input type="text" class="form-control generalInput" id="documentNumberCompany"
              v-model.trim.lazy="v$.documentNumberCompany.$model">
            <div v-if="v$.documentNumberCompany.$dirty">
              <small class="form-text text-danger" v-if="v$.documentNumberCompany.$invalid">CIF incorrecto</small>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-3">
          <div class="form-group">
            <label class="generalLabel" for="from">Creación cliente, desde</label>
            <DatePicker v-model="from" mode="date" :model-config="modelConfig">
              <template v-slot="{ togglePopover }">
                <input @click="togglePopover()" class="form-control generalInput bg-white" readonly v-model="from" />
                <v-icon name="ri-calendar-line" scale="0.9" class="generalSelect__iconDate" @click="togglePopover()" />
              </template>
            </DatePicker>
          </div>
        </div>
        <div class="col-12 col-lg-3">
          <div class="form-group">
            <label class="generalLabel" for="to">Creación cliente, hasta</label>
            <DatePicker v-model="to" mode="date" :model-config="modelConfig">
              <template v-slot="{ togglePopover }">
                <input @click="togglePopover()" class="form-control generalInput bg-white" readonly v-model="to" />
                <v-icon name="ri-calendar-line" scale="0.9" class="generalSelect__iconDate" @click="togglePopover()" />
              </template>
            </DatePicker>
          </div>
        </div>
        <div class="col-12 col-lg-3">
          <div class="form-group">
            <label class="generalLabel" for="phone">Móvil</label>
            <input type="text" class="form-control generalInput" id="phone" v-model.trim="phone">
          </div>
        </div>
        <div v-if="($store.state.roles.Backoffice_member || $store.state.roles.Backoffice_supervisor) && !$store.state.roles.Backoffice_member_empresas" class="col-12 col-lg-3 pt-4">
          <div class="form-group mb-0 h-100 d-flex align-items-center align-content-middle">
            <div class="custom-control custom-checkbox">
              <input type="checkbox" class="custom-control-input" id="whiteList" v-model.trim="whiteList" />
              <label class="custom-control-label labelCheck" for="whiteList">Cliente añadido a la White List</label>
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="h-100 d-flex justify-content-end align-items-end align-content-end">
            <button class="btn generalSecondaryButton" @click="cleanSearch()">Limpiar</button>
            <button class="btn btn-primary generalPrimaryButton" :disabled="v$.$invalid">Buscar</button>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div v-else>
    <div class="filterHeader link-primary d-flex align-items-center justify-content-between" data-toggle="collapse" href="#filterCollapse" role="button" aria-expanded="false" aria-controls="filterCollapse">
      <p class="m-0">
        FILTROS
      </p>
      <v-icon name="bi-filter" scale="1.5" />
    </div>
    <hr/>
    <div class="collapse" id="filterCollapse">
      <form @submit.prevent="filter()" v-on:keypress.enter.prevent="enterKey">
        <div class="row">
          <div class="col-12 col-lg-3">
            <div class="form-group">
              <label class="generalLabel" for="name" v-if="!$store.state.roles.Backoffice_member_empresas">Nombre</label>
              <label class="generalLabel" for="name" v-if="$store.state.roles.Backoffice_member_empresas">Nombre de la compañía</label>
              <input type="text" class="form-control generalInput" id="name" v-model.trim="name">
            </div>
          </div>
          <div class="col-12 col-lg-3" v-if="!$store.state.roles.Backoffice_member_empresas">
            <div class="form-group">
              <label class="generalLabel" for="surnames">Apellidos</label>
              <input type="text" class="form-control generalInput" id="surnames" v-model.trim="surnames">
            </div>
          </div>
          <div class="col-12 col-lg-3">
            <div class="form-group">
              <label class="generalLabel" for="email">Email</label>
              <input type="text" class="form-control generalInput" id="email" v-model.trim.lazy="v$.email.$model">
              <small class="form-text text-danger" v-if="v$.email.$invalid">Formato incorrecto</small>
            </div>
          </div>
          <div class="col-12 col-lg-3" v-if="!$store.state.roles.Backoffice_member_empresas">
            <div class="form-group">
              <label class="generalLabel" for="documentNumber">DNI</label>
              <input type="text" class="form-control generalInput" id="documentNumber"
                v-model.trim.lazy="v$.documentNumber.$model">
              <div v-if="v$.documentNumber.$dirty">
                <small class="form-text text-danger" v-if="v$.documentNumber.dniNumber.$invalid">DNI
                  incorrecto</small>
              </div>
            </div>
          </div>
          <div class="col-12 col-lg-3" v-if="$store.state.roles.Backoffice_member_empresas">
            <div class="form-group">
              <label class="generalLabel" for="documentNumberCompany">CIF</label>
              <input type="text" class="form-control generalInput" id="documentNumberCompany"
                v-model.trim.lazy="v$.documentNumberCompany.$model">
              <div v-if="v$.documentNumberCompany.$dirty">
                <small class="form-text text-danger" v-if="v$.documentNumberCompany.$invalid">CIF incorrecto</small>
              </div>
            </div>
          </div>
          <div class="col-12 col-lg-3">
            <div class="form-group">
              <label class="generalLabel" for="from">Creación cliente, desde</label>
              <DatePicker v-model="from" mode="date" :model-config="modelConfig">
                <template v-slot="{ togglePopover }">
                  <input @click="togglePopover()" class="form-control generalInput bg-white" readonly v-model="from" />
                  <v-icon name="ri-calendar-line" scale="0.9" class="generalSelect__iconDate" @click="togglePopover()" />
                </template>
              </DatePicker>
            </div>
          </div>
          <div class="col-12 col-lg-3">
            <div class="form-group">
              <label class="generalLabel" for="to">Creación cliente, hasta</label>
              <DatePicker v-model="to" mode="date" :model-config="modelConfig">
                <template v-slot="{ togglePopover }">
                  <input @click="togglePopover()" class="form-control generalInput bg-white" readonly v-model="to" />
                  <v-icon name="ri-calendar-line" scale="0.9" class="generalSelect__iconDate" @click="togglePopover()" />
                </template>
              </DatePicker>
            </div>
          </div>
          <div class="col-12 col-lg-3">
            <div class="form-group">
              <label class="generalLabel" for="phone">Móvil</label>
              <input type="text" class="form-control generalInput" id="phone" v-model.trim="phone">
            </div>
          </div>
          <div v-if="($store.state.roles.Backoffice_member || $store.state.roles.Backoffice_supervisor) && !$store.state.roles.Backoffice_member_empresas" class="col-12 col-lg-3 pt-4">
            <div class="form-group mb-0 h-100 d-flex align-items-center align-content-middle">
              <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input" id="whiteList" v-model.trim="whiteList" />
                <label class="custom-control-label labelCheck" for="whiteList">Cliente añadido a la White List</label>
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="h-100 d-flex justify-content-end align-items-end align-content-end">
              <button class="btn generalSecondaryButton" @click="cleanSearch()">Limpiar</button>
              <button class="btn btn-primary generalPrimaryButton" :disabled="v$.$invalid">Buscar</button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>
<script>
import { DatePicker } from 'v-calendar';
import useVuelidate from '@vuelidate/core';
import { email } from '@vuelidate/validators'

const dniNumber = (value) => {
  if (value != '') {
    var numero, le, letra;
    var expresion_regular_dni = /^[XYZ]?\d{5,8}[A-Z]$/;

    value = value.toUpperCase();

    if (expresion_regular_dni.test(value) === true) {
      numero = value.substr(0, value.length - 1);
      numero = numero.replace('X', 0);
      numero = numero.replace('Y', 1);
      numero = numero.replace('Z', 2);
      le = value.substr(value.length - 1, 1);
      numero = numero % 23;
      letra = 'TRWAGMYFPDXBNJZSQVHLCKET';
      letra = letra.substring(numero, numero + 1);
      if (letra != le) {
        return false;
      } else {
        return true;
      }
    } else {
      return false;
    }
  } else {
    return true
  }
}

const validateCIF = (value) => {
  if (value != "") {
    // Strip any whitespace and convert to uppercase
    value = value.trim().toUpperCase();

    // Check length
    if (value.length !== 9) {
      return false;
    }

    // Check first letter (must be A, B, C, D, E, F, G, H, J, N, P, Q, R, S, U, V, W)
    const firstLetter = value[0];
    if (!"ABCDEFGHJNPQRSUVW".includes(firstLetter)) {
      return false;
    }

    // Check last digit (control digit)
    const lastDigit = parseInt(value[8]);
    let controlDigit = 0;
    let total = 0;
    for (let i = 2; i < 8; i += 2) {
      const c = parseInt(value[i]);
      total += c;
    }
    for (let i = 1; i < 8; i += 2) { 
      const c = parseInt(value[i]);
      total += [...(c * 2).toString()].reduce((sum, d) => sum + parseInt(d), 0); 
    }
    controlDigit = (10 - (total % 10)) % 10;
    if (controlDigit !== lastDigit) {
      return false;
    }

    // All checks passed
    return true;
  } else {
    return true
  }

}

export default {
  name: 'ContractFilters',
  components: {
    DatePicker,
  },
  setup() {
    return { v$: useVuelidate() }
  },
  data() {
    return {
      name: '',
      from: '',
      to: '',
      surnames: '',
      email: '',
      documentNumber: '',
      documentNumberCompany: '',
      phone: '',
      whiteList: '',
      modelConfig: {
        type: 'string',
        mask: 'DD/MM/YYYY',
      },
      CNAENumber: '',
    };
  },
  validations() {
    return {
      documentNumber: {
        dniNumber
      },
      documentNumberCompany: {
        validateCIF
      },
      email: {
        email
      }
    }
  },
  computed: {
    filtersApplied() {
      // `this` apunta a la instancia vm
      return {
        name: this.name,
        from: this.from,
        to: this.to,
        surnames: this.surnames,
        email: this.email,
        documentNumber: this.documentNumber,
        documentNumberCompany: this.documentNumberCompany,
        phone: this.phone,
        whiteList: this.whiteList
      };
    },
  },
  methods: {
    filter() {
      this.$emit('filter', this.filtersApplied);
    },
    cleanSearch() {
      this.name = '';
      this.from = '';
      this.to = '';
      this.surnames = '';
      this.email = '';
      this.documentNumber = '';
      this.documentNumberCompany = '';
      this.phone = '';
      this.whiteList = '';
    },
    enterKey: function (e) {
      if (e.keyCode === 13) {
        this.filter();
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '../../../scss/variables.scss';

.filterHeader {
  font-size: 1.143rem;
  line-height: 1.5;
}
.link-primary {
  color:$primary;
  cursor:pointer;

  &:hover {
    color: $primary-hover;
  }
}
</style>
